import React from 'react'

function Loader() {
  return (
    <div className='fixed w-full h-screen top-0 left-0 bg-black/60 flex justify-center items-center z-[1000]'>
        <div className='loader'></div>
    </div>
  )
}

export default Loader
